import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Names } from '@ils/static/names.js';

@Entity()
export class OSCEText extends AdornisEntity {
  static override _class = Names.OSCEText._class;
  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => String)
  shortDescription!: string; // TODO put in Next Up screen

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => String)
  sceneDescriptionTrainee!: string;

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => String)
  taskDescriptionTrainee!: string;

  @Field(type => String) // TODO think about validator again, text tasks have no tester..
  sceneDescriptionTester: Maybe<string>;
}
